import React from "react";
import { useNavigate } from "react-router-dom";
const PrimaryButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/contact");
    window.scrollTo(0, 0);
  };
  return (
    <div>
      <button
        className=" text-primaryBlue bg-white  hover:text-navyBlue  hover:bg-graydark  font-semibold
    p-1 px-3 md:p-2 md:px-5 font-arimo  rounded-full text-base md:text-lg lg:text-xl"
        onClick={handleClick}
      >
        Get In Touch
      </button>
    </div>
  );
};

export default PrimaryButton;
